export const initialSliderValue = 5; // minutes
